import { useContext, useEffect, useState } from 'react'

import type { WorkId } from '../../../../types/WorkId'
import { WorksDataContext, WorksDataDispatch, type IWorksDataContext } from './WorksDataContext'

export type IUseWorksDataContext = IWorksDataContext & {
  workIdsWithValidQuantities: WorkId[]
  workIdsWithInvalidQuantities: WorkId[]
}

export function useWorksDataContext() {
  const worksDataContext = useContext(WorksDataContext)

  const [workIdsWithValidQuantities, setWorkIdsWithValidQuantities] = useState<WorkId[]>([])
  const [workIdsWithInvalidQuantities, setWorkIdsWithInvalidQuantities] = useState<WorkId[]>([])

  useEffect(() => {
    if (!worksDataContext?.worksData) {
      return
    }
    const allWorkIds = Object.keys(worksDataContext.worksData)
    const valid: WorkId[] = []
    const inValid: WorkId[] = []
    allWorkIds.forEach((workId) => {
      const workData = worksDataContext.worksData[workId]
      if (!(workData?.isDeleted ?? false) && !(workData?.isDeleting ?? false)) {
        if (workData?.isValidQuantity) {
          valid.push(workId)
        } else {
          inValid.push(workId)
        }
      }
    })
    setWorkIdsWithInvalidQuantities(inValid)
    setWorkIdsWithValidQuantities(valid)
  }, [worksDataContext.isWorkQuantitiesValid, worksDataContext.worksData])

  return {
    ...worksDataContext,
    workIdsWithValidQuantities,
    workIdsWithInvalidQuantities,
  }
}

export function useWorksDataDispatch() {
  return useContext(WorksDataDispatch)
}
